<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="操作时间：">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>                
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid"  @keyup.enter.native="getSimStopStartRecordListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="接入号：">
                <el-input v-model.trim="searchForm.intoNo"  @keyup.enter.native="getSimStopStartRecordListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getSimStopStartRecordListHandler">搜索查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  > 
            <el-table-column label="ICCID号" width="160">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号"></el-table-column>
            <el-table-column prop="createTypeName" label="类型"></el-table-column>
            <el-table-column prop="createTime" label="操作时间 "></el-table-column>
            <el-table-column prop="createOptName" label="操作人"></el-table-column>
            <el-table-column prop="failReason" label="失败原因"></el-table-column>            
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>   
    </div>
</template>
<script>
import {getSimStopStartRecordList} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                time: '',
                iccid: '',
                intoNo: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            }
        }
    },
    methods: {
        getSimStopStartRecordListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);  
            getSimStopStartRecordList(data).then( res => {
                common.listCallback(this, res, 'tbpg'); 
            })
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getSimStopStartRecordListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val
            this.getSimStopStartRecordListHandler();
        }        
    },
    created(){
        this.getSimStopStartRecordListHandler();
    }
}
</script>
<style lang="less" scoped>

</style>

